import { makeStyles } from '@mui/styles';

const useProcessesContainerStyles = makeStyles({
	root: {
		marginTop: 16,
		overflowX: 'hidden',
		overflowY: 'auto',
		scrollbarColor: '#c7c7c7 #E9E9E9',
		scrollbarWidth: 'thin',
		width: '100%',
		'&::-webkit-scrollbar': {
			width: 6,
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#E9E9E9',
			borderRadius: 7,
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#c7c7c7',
			borderRadius: 7,
		},
	},
	titleContainer: {
		marginTop: 24,
	},
	scrollContainer: {
		display: 'flex',
		flexFlow: 'row wrap',
		gap: 8,
	},
});

export default useProcessesContainerStyles;
